define('notifications/trial-ending-marvel-notification/trial-ending-marvel-notification',['require','api-access','moment','lib/models/account/find-expiring-trial','lib/models/account/check-billing-admin','api-access','mixpanel-helper','jquery','tealium-utils','product-purchase-modal/product-purchase-modal','lib/multivariate-testing/multivariate-testing'],function (require) {
    var user = require('api-access').user;
    var moment = require('moment');
    var findExpiringTrial = require('lib/models/account/find-expiring-trial');
    var checkBillingAdmin = require('lib/models/account/check-billing-admin');
    var commerceApi = require('api-access').commerce;
    var mixpanelHelper = require('mixpanel-helper');
    var $ = require('jquery');
    var tealiumUtils = require('tealium-utils');
    var ProductPurchaseModal = require('product-purchase-modal/product-purchase-modal');
    var multivariateTesting = require('lib/multivariate-testing/multivariate-testing');

    return function () {
        var self = this;

        self.show = function () {
            return $.when(
                user.me(),
                commerceApi.getProducts(),
                multivariateTesting.checkVariation('inProductPurchaseTest')
            ).then(function (userMe, products, variation) {
                var isAccountAdmin = checkBillingAdmin(products[0], userMe[0].key);
                var expiringTrial = findExpiringTrial(products[0]);

                if (expiringTrial) {
                    var trialDaysLeft = moment(expiringTrial.endDate).diff(moment(), 'days');

                    if (trialDaysLeft === 3 || trialDaysLeft === 2) {
                        user.updateSettings({marvelTrial3DayLeftViewed: true});
                    } else if (trialDaysLeft === 1 || trialDaysLeft === 0) {
                        user.updateSettings({marvelTrial1DayLeftViewed: true});
                    }

                    mixpanelHelper.track('Marvel expiring trial: Show');
                    tealiumUtils.sendTealiumEvent('meetings', 'trial_expiration_modal');

                    ProductPurchaseModal.show({
                        props: {
                            initialPage: 'g2m-trial-promo',
                            isAccountAdmin: isAccountAdmin,

                            // Trial days left is rounded down. On the last day, the value will be 0,
                            // but we still want to show 1
                            trialDaysLeft: trialDaysLeft || 1,
                            isRedirectCommerce: variation !== 'variation-a',
                            productKey: 'GoToMeeting'
                        },

                        onClose: function () {
                            mixpanelHelper.track('Marvel expiring trial: Dismiss');
                        }
                    });
                }
            });
        };
    };
});

